import { AfterViewInit, Component, OnInit, signal } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { SecurityService } from '../../services/security.service';
import { environment } from '@env/environment';
import { CommonModule } from '@angular/common';
import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'app-home',
  imports: [
    CommonModule,
    RouterModule
  ],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, AfterViewInit {

  colorOne = environment.colorOne;
  colorTwo = environment.colorTwo;
  webVersion = localStorage.getItem('version');

  internalCode: string | null = null;
  consultor = signal<any | null>(null);
  nextRoute = '/app/services';


  constructor(
    private title: Title,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private securityService: SecurityService,
    private _loaderService: LoaderService

  ) {
    this.title.setTitle('Onboarding Digital | Inicio');
    this.internalCode = this.activatedRoute.snapshot.paramMap.get('internalCode');
  }

  async ngOnInit() {
    const route = localStorage.getItem('route');
    const currentUrl = this.router.url;
    if(route && currentUrl !== route && this.isValidRoute(route)) {
      await this.router.navigateByUrl(route);
    } else {
      if(route && !this.isValidRoute(route)) {
        localStorage.removeItem('route');
      }
      if (this.internalCode != null) {
        this.loadConsultorByInternalCode(this.internalCode);
      } else if (localStorage.getItem('consultor')) {
        this.loadConsultorFromSession();
      }
    }
  }

  ngAfterViewInit(): void {
    this._loaderService.hide();
  }

  private isValidRoute(route: string): boolean {
    const hasSession = localStorage.getItem('session');
    const hasConsultor = localStorage.getItem('consultor');

    if(!hasSession || !hasConsultor) {
      localStorage.removeItem('route');
      return false;
    }
    return true;
  }

  private loadConsultorByInternalCode(code: string): void {
    this._loaderService.show();
    localStorage.setItem('consultor', code);
    this.securityService.setConsultor(code).subscribe({
      next: (response: any) => {
        this.setConsultorData(response);
        this._loaderService.hide();

      },
      error: (error) => {
        console.error('Error loading consultor by internal code:', error);
        this._loaderService.hide();
      }
    });
  }

  private loadConsultorFromSession(): void {
    this._loaderService.show();
    this.securityService.getConsultor().subscribe({
      next: (response: any) => {
        this.setConsultorData(response);
        this._loaderService.hide();

      },
      error: (error) => {
        console.error('No consultor found in session:', error);
        this._loaderService.hide();

      }
    });
  }

  private setConsultorData(data: any): void {
    this.consultor.set({
      ...data,
      qrImage: `${environment.serverUrl}/assets/qr/${data.qrCode}`
    });
  }

  async next() {
    this._loaderService.show();
      localStorage.setItem('route', this.nextRoute);
      this.router.navigateByUrl(this.nextRoute);
  }

}
